import { type FC, type ReactNode } from "react";
import { ArrowRight, Loader2 } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { FieldError } from "@/shared/components/ui/FieldError";

interface AddItemLayoutProps {
  onSubmit: () => void;
  isSubmitting: boolean;
  error: string | null;
  disabled?: boolean;
  onSkip?: () => void;
  skipLabel?: string;
  children: ReactNode;
}

export const AddItemLayout: FC<AddItemLayoutProps> = ({
  onSubmit,
  isSubmitting,
  error,
  disabled,
  onSkip,
  skipLabel = "I'll add the details later",
  children,
}) => {
  return (
    <div className="mx-auto flex w-full max-w-[600px] flex-col gap-6">
      <div className="rounded-lg border border-primary bg-white px-3 py-4 sm:p-6">{children}</div>

      {error && <FieldError message={error} />}

      <div className="flex flex-col items-center gap-3">
        <Button
          variant="brand"
          rounded={true}
          onClick={onSubmit}
          disabled={isSubmitting || disabled}
          className="w-full"
        >
          {isSubmitting ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <>
              Continue <ArrowRight className="h-4 w-4" />
            </>
          )}
        </Button>
        {onSkip && (
          <Button variant="link" className="text-secondary" onClick={onSkip}>
            {skipLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
